"use client";

export type SupportChatMessage = {
  id: number;
  body: string;
  isStaff: boolean;
  staffName?: string | null;
  createdAt: string;
};

export type StartChatResult = {
  ticketId: number;
  sessionToken: string;
  stage: string;
  message: SupportChatMessage;
};

export type ThreadResult = {
  ticket: { id: number; stage: string };
  messages: SupportChatMessage[];
};

function strapiUrl(): string {
  const url = process.env.NEXT_PUBLIC_STRAPI_URL;
  if (!url) throw new Error("NEXT_PUBLIC_STRAPI_URL is not configured");
  return url.replace(/\/$/, "");
}

export async function startChat(args: {
  message: string;
  name?: string;
  email?: string;
  locale: "de" | "en";
}): Promise<StartChatResult> {
  const res = await fetch(`${strapiUrl()}/api/support-tickets/public-chat/start`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(args),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`startChat failed: ${res.status} ${text}`);
  }
  return res.json();
}

export async function postMessage(args: {
  ticketId: number;
  sessionToken: string;
  body: string;
}): Promise<{ message: SupportChatMessage }> {
  const res = await fetch(
    `${strapiUrl()}/api/support-tickets/public-chat/${args.ticketId}/message`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Session-Token": args.sessionToken,
      },
      body: JSON.stringify({ body: args.body }),
    }
  );
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`postMessage failed: ${res.status} ${text}`);
  }
  return res.json();
}

export async function getThread(args: {
  ticketId: number;
  sessionToken: string;
}): Promise<ThreadResult> {
  const res = await fetch(
    `${strapiUrl()}/api/support-tickets/public-chat/${args.ticketId}/thread`,
    {
      method: "GET",
      headers: { "X-Session-Token": args.sessionToken },
    }
  );
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`getThread failed: ${res.status} ${text}`);
  }
  return res.json();
}
